import React from 'react';

import ProjectsPaywall, { ProjectsPaywallProps } from '@components/ProjectsPaywall';
import { LeadType } from '@utils/types';

interface PaywallProps {
  leadType: LeadType;
  paywallData: ProjectsPaywallProps;
}

const Paywall = ({ leadType, paywallData }: PaywallProps) => {
  return (
    <>
      <div className="relative before:absolute before:bottom-0 before:left-0 before:z-10 before:h-[300px] before:w-full before:bg-[linear-gradient(to_top,#fff_0%,rgba(255,255,255,0)_100%)] before:content-[''] dark:before:bg-[linear-gradient(to_top,#1a1a1a_0%,rgba(26,26,26,0)_100%)]"></div>
      <div className="sticky bottom-0 z-50">
        <ProjectsPaywall {...paywallData} leadType={leadType} />
      </div>
    </>
  );
};

export default Paywall;
